var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Grid',{attrs:{"fstyle":{
    justifyContent: 'space-evenly',
    flexDirection: 'column',
    height: '100%',
    alignItems: 'center',
  }}},[_vm._l((_vm.poleState),function(chip,idx){return [_c('div',{key:idx,class:chip.active
          ? 'Chip Active ' + chip.className
          : 'Chip ' + chip.className,style:(chip.active
          ? _vm.formatColor(chip.colorActive, chip.bgActive)
          : _vm.formatColor(chip.color, chip.bg)),on:{"click":function($event){return _vm.dispatch({ type: 'chip', idx: idx })}}},[_c('Indicator',{attrs:{"state":chip}}),_c('div',{staticClass:"Text"},[_vm._v(" "+_vm._s(_vm.$t(chip.text))+" ")])],1)]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }